import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { ManifestEntry } from "./inbound-manifest";

interface SearchCatalogueModalProps {
  show: boolean;
  onHide: () => void;
  productSku: string;
  itemDescription: string;
  initialStatus: ManifestEntry["catalogueStatus"];
  onSave: (status: ManifestEntry["catalogueStatus"]) => void;
}

const SearchCatalogueModal = ({
  show,
  onHide,
  productSku,
  itemDescription,
  initialStatus,
  onSave,
}: SearchCatalogueModalProps) => {
  const [selectedStatus, setSelectedStatus] = useState<
    ManifestEntry["catalogueStatus"]
  >(initialStatus || "No Match Found");

  const handleSave = () => {
    onSave(selectedStatus);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Search in Catalogue</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Search for: <strong>{productSku || ""}</strong>
        </p>
        <p>
          Description: <strong>{itemDescription || ""}</strong>
        </p>

        <Form.Group className="mb-3">
          <Form.Label>Catalogue Status</Form.Label>
          <Form.Select
            value={selectedStatus || ""}
            onChange={(e) =>
              setSelectedStatus(
                e.target.value as ManifestEntry["catalogueStatus"]
              )
            }
          >
            <option value="Matched">Matched</option>
            <option value="No Match Found">No Match Found</option>
            <option value="Possible Match">Possible Match</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SearchCatalogueModal;
